<div class="current-selection row">
       
            <div class="content">
            <div *ngIf="selection"
             [ngClass]="getSelectionPanelWidth()">
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-5">
                    <div class="currently-reading-text">
                    <h4>Currently Reading</h4>
                    </div>
                    <div class="row">
                        <a (click)="selectionClick()">
                            <img class="selection-box-image"
                                 src="{{ getLibraryImage(selection.storyDescription.coverImage) }}"
                                 alt="{{selection.storyDescription.fullTitle}}">
                        </a>
    
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-4 col-sm-5 no-gutter mt-2">
                    <div class="story-title">
                    <h4>{{selection.storyDescription.fullTitle}}</h4>
                   </div>
                    <div>
                        <h6 class="progress-heading">Your Progress:</h6>
                     <div class="row m-0">
                         <div class="col-xs-3 p-0">
                            <div class="icon-step " [ngClass]="getClassForStep(1)"></div>
                            <span class="step-span">Step 1</span>
                        </div>
                        <div class="col-xs-3 p-0">
                            <div class="icon-step connecting-line" [ngClass]="getClassForStep(2)"></div>
                            <span class="step-span">Step 2</span>
                        </div>
                        <div class="col-xs-3 p-0">
                            <div class="icon-step" [ngClass]="getClassForStep(3)"></div>
                            <span class="step-span">Step 3</span>
                        </div>
                    </div>
                    </div>
                    <div class="selection-go" (click)="selectionClick()"></div>

                </div>

        </div>

        <div class="col-sm-12 col-lg-3 current-selection-box" *ngIf="!selection && nextSelection" >
            <div class="row">
                <div class="col-xs-5">
                    <h4>{{nextSelection.storyDescription.shortTitle}}</h4>
                    <p>{{nextSelection.storyDescription.fullTitle}}</p>
                </div>
                <div class="col-xs-5">
                    <a (click)="selectionClick()">
                        <img class="current-selection-media-wrap"
                             src="{{ getLibraryImage(nextSelection.storyDescription.coverImage) }}"
                             alt="{{nextSelection.storyDescription.fullTitle}}">
                    </a>
                </div>
                <div class="col-xs-2 current-selection-go" (click)="nextSelectionClick()">
                </div>
            </div>
        </div>
        <div class="col-xs-4 current-selection-next-box" *ngIf="selection && !nextSelection">
        </div>
</div>
</div>
